"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Live(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M22 5c1.09 0 2 .91 2 2v10c0 1.09-.91 2-2 2H6c-1.09 0-2-.91-2-2V7c0-1.09.91-2 2-2zm0 2H6v10h16V7zM0 20h2V4H0v16zm7.233-4.438h1.485v-6.75H7.233v6.75zm2.473 0h1.485v-4.755H9.706v4.755zm-.088-5.981a.66.66 0 0 1 .229-.519c.152-.134.349-.202.593-.202.243 0 .441.068.593.202a.66.66 0 0 1 .229.519.657.657 0 0 1-.229.518c-.152.135-.35.203-.593.203-.244 0-.441-.068-.593-.203a.657.657 0 0 1-.229-.518zM14 13.8l.751-2.993h1.561l-1.551 4.755h-1.512l-1.552-4.755h1.565L14 13.8zm4.838-3.082c.668 0 1.195.207 1.582.622.387.415.58.993.58 1.734v.575h-2.944c.052.268.168.477.347.63.178.151.41.228.694.228.468 0 .836-.165 1.1-.493l.675.8a1.883 1.883 0 0 1-.784.61 2.646 2.646 0 0 1-1.092.225c-.729 0-1.32-.218-1.77-.652-.453-.436-.678-1-.678-1.699v-.124c0-.485.091-.915.27-1.287.181-.372.444-.66.79-.863.345-.204.755-.306 1.23-.306zm-.009 1.143c-.434 0-.69.287-.773.861h1.494v-.114c.006-.237-.055-.42-.18-.552-.127-.13-.307-.195-.54-.195z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Live;
